import { Decorative, Core } from "@faire/design-tokens";
import styled from "styled-components";

interface IProps {
  /** How much filled region the component have. It should range from 0 ~ 100 */
  $progress: number;
}

export const OwFCreditProgressBar = styled.div<IProps>`
  position: relative;
  height: 10px;
  background-color: ${Core.surface.subdued};
  flex: 1;
  border-radius: 5px;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    background-color: ${Decorative.icon.blue};
    height: 100%;
    width: 100%;
    animation: slideIn 1000ms forwards;
    transform-origin: left;
    transform: scaleX(${({ $progress: progress }) => progress}%);

    @keyframes slideIn {
      from {
        transform: scaleX(0%);
      }
    }
  }
`;
